import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CutoffService } from 'src/app/services/cutoff.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { InventorysService } from 'src/app/services/inventory.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-project-diagramation-summary-inventory',
  templateUrl: './project-diagramation-summary-inventory.component.html',
  styleUrls: ['./project-diagramation-summary-inventory.component.scss']
})
export class ProjectDiagramationSummaryInventoryComponent implements OnInit, AfterViewInit {
  @ViewChild("paginatorSuc") paginatorSuc!: MatPaginator;
  @ViewChild("sortSuc") sortSuc!: MatSort;

  id_proy: number = 0;
  id_camp: number = 0;
  medios: any[] = [];
  elementos: any[] = [];
  medio_sel: any;
  pop_sel: any;
  materiales_dist: any[] = [];

  projectAllDiagramations: any[] = [];
  dsstoreFile: MatTableDataSource<any> = new MatTableDataSource();
  storeFile: any[] = [];
  displayedColumnsStore: string[] = [];
  allColumnsStore: string[] = [];

  def_fields_stores: any = ["id", "Plaza", "FarmID", "Nombre"];
  arr_cant: any[] = [];
  arr_reglas: any[] = [];
  extra_stores_data: any[] = [];
  selected_attributes: any[] = [];
  dt_totales: any[] = [];
  columnFilters: { [key: string]: string } = {};
  plazasList: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProjectDiagramationSummaryInventoryComponent>,
    private projectsS: ProjectsService,
    private main: MainService,
    private _cutoffS: CutoffService,
    private invService: InventorysService,
    private cdr: ChangeDetectorRef
  ) {
    this.id_proy = parseInt(data.id_proy);
    this.id_camp = data.projectData.id_proy_camp;
    this.selected_attributes = data.projectData.selected_attributes ? JSON.parse(data.projectData.selected_attributes) : [];
    this.projectAllDiagramations = data.projectAllDiagramations;
  }

  ngOnInit(): void {
    this.main.ShowLoading();
    this._cutoffS.checkIfSameProjectThenReplace(this.id_camp).then(() => {
      this.getMedios();
      this.getExtraStoreData();
      this.main.HideLoading();
    });
  }

  ngAfterViewInit(): void {
    this.dsstoreFile.paginator = this.paginatorSuc;
    this.dsstoreFile.sort = this.sortSuc;
  }

  getMedios() {
    this.main.ShowLoading();
    this.projectsS.getMedios(this.id_camp).subscribe({
      next: (x: any) => {
        const created_diagramations_off = this.projectAllDiagramations.filter((e: any) => e.id_proyecto != this.id_proy && e.id_proyecto != 0);
        this.medios = x.data.medios.filter((medio: any) => {
          const isUsedInOtherProject = created_diagramations_off.some((diag: any) => diag.id_medio == medio.id);
          return !isUsedInOtherProject;
        });

        this.main.HideLoading();
      },
      error: (err: any) => {
        console.log(err);
        this.main.HideLoading();
      }
    });
  }

  medioSelected(id_media: number) {
    this.elementos = [];
    this.dsstoreFile.data = [];
    if (!id_media) return;

    this.medio_sel = this.medios.find((e: any) => e.id == id_media);
    this.getPops(id_media);
  }

  getPops(id_medio: number) {
    this.main.ShowLoading();
    this.projectsS.getPOPs(id_medio).subscribe({
      next: (x: any) => {
        const created_diagramations = this.projectAllDiagramations.filter((e: any) => e.id_medio == this.medio_sel.id);
        const created_diagramations_off = this.projectAllDiagramations.filter((e: any) => e.id_medio == this.medio_sel.id && e.id_proyecto != this.id_proy);

        const used_el = x.data.elementos_pop.map((e: any) => {
          const f = created_diagramations.filter((a: any) => a.id_pop === e.id);
          return { pop: e.nombre, positions: f.length };
        });

        let availableElements = x.data.elementos_pop.filter((e: any) => {
          return !created_diagramations_off.some((a: any) => a.id_pop == e.id);
        });

        availableElements = availableElements.filter((e: any) => {
          const f = used_el.find((a: any) => a.pop == e.nombre);
          return (!e.posiciones || e.posiciones == 0 || (f?.positions ?? 0) < e.posiciones);
        });

        this.elementos = availableElements;
        this.main.HideLoading();
      },
      error: (err: any) => {
        console.log(err);
        this.main.HideLoading();
      }
    });
  }

  popSelected(el_pops: any) {
    this.dsstoreFile.data = [];
    if (!el_pops) return;

    this.main.ShowLoading();
    this.pop_sel = this.elementos.find((e: any) => e.id == el_pops);

    this.projectsS.getPOPConfigs(el_pops).subscribe({
      next: (x: any) => {
        this.materiales_dist = x.data.configs;
        this.getInventoryAndProcess();
      },
      error: (err: any) => {
        console.log(err);
        this.main.HideLoading();
      }
    });
  }

  getInventoryAndProcess() {
    let filtros_sucursal: any = [];
    if (this.pop_sel.sucursales_filtro) filtros_sucursal = JSON.parse(this.pop_sel.sucursales_filtro);
    if (this.medio_sel.sucursales_filtro) filtros_sucursal = [...filtros_sucursal, ...JSON.parse(this.medio_sel.sucursales_filtro)];

    this.invService.getInventory(this.id_proy, this.id_camp, this._cutoffS, this.medio_sel.id, this.pop_sel.id, filtros_sucursal, this.selected_attributes)
      .then((res_dt_totales: any) => {
        if (!res_dt_totales || res_dt_totales.length === 0 || res_dt_totales.every((inv: any) => inv.inventario <= 0)) {
          Swal.fire({
            icon: 'warning',
            title: 'Inventario no disponible',
            text: 'No hay inventario disponible para la configuración seleccionada.'
          });
          this.main.HideLoading();
          return;
        }
        if (this.medio_sel.inventario_type == 1) {
          this.dt_totales = res_dt_totales.filter((rd: any) => rd.id_medio == this.medio_sel.id);
        } else {
          this.dt_totales = res_dt_totales.filter((rd: any) => rd.id_medio == this.medio_sel.id && rd.id_pop == this.pop_sel.id);
        }

        this.processInventorySummary();
        this.main.HideLoading();
      });
  }

  isEmpyConfig(json: any): boolean {
    let empyconfig = true;
    try {
      if (JSON.parse(json)[0].id > 0) {
        empyconfig = false;
      }
    } catch (ex) { }
    return empyconfig;
  }

  processInventorySummary() {
    this.arr_reglas = [];
    this.materiales_dist.forEach((config: any) => {
      const config_sel = config;
      let r: any = {};
      if (this.medio_sel.formato == 3) {
        r = JSON.parse(this.medio_sel.prioridad_filtro)[0];
        r.cant_type = 4; // de por maximos
      } else if (this.medio_sel.formato == 2) {
        r = JSON.parse(this.medio_sel.prioridad_filtro)[0];
        r.cant_type = 3;
      } else if (!config.reglas_distribucion || config.reglas_distribucion.length == 0 || config.reglas_distribucion == "[]" || this.isEmpyConfig(config.reglas_distribucion)) {
        r = { cant_type: 1, multiplicador: config.cantidad, nombre: config.nombre };
      } else {
        r = JSON.parse(config_sel.reglas_distribucion)[0];
        r.cant_type = 2;
      }
      r.inventario_type = this.medio_sel.inventario_type;
      r.atributo = r.nombre;
      r.nombre = r.inventario_type == 1 ? this.medio_sel.nombre : (r.inventario_type == 2 ? this.pop_sel.nombre : (r.inventario_type == 3 ? config.nombre : r.atributo));
      r.id_pop_config = config_sel.id;
      this.arr_reglas.push(r);
    });

    let arr_fields_stores: any[] = [];
    this.selected_attributes.forEach(attr => {
      if (attr && !this.def_fields_stores.includes(attr) && attr.trim() !== '') {
        this.def_fields_stores.push(attr);
      }
    });

    this.arr_cant = [];
    this.arr_reglas.forEach(e => {
      if (e.nombre) {
        if (e.atributo) arr_fields_stores.push(e.atributo);
        this.arr_cant.push({
          id_pc: e.id_pop_config,
          nombre: e.nombre,
          atributo: e.atributo,
          cantidad: e.multiplicador,
          tipo: e.cant_type
        });
      }
    });

    arr_fields_stores = [...new Set([...this.def_fields_stores, ...arr_fields_stores.filter(f => f)])];

    let filtros: any = [];
    if (this.pop_sel.sucursales_filtro) filtros = JSON.parse(this.pop_sel.sucursales_filtro);
    if (this.medio_sel.sucursales_filtro) filtros = [...filtros, ...JSON.parse(this.medio_sel.sucursales_filtro)];

    this.storeFile = this._cutoffS.filtrarSucursales(filtros).map((e: any) => {
      let obj_store: any = {};
      arr_fields_stores.forEach((key: any) => {
        obj_store[key] = e[key] || '';
      });
      return obj_store;
    });

    if ((this.medio_sel.formato === 3 || this.medio_sel.formato === 2)) {
      const file_suc_full = this._cutoffS.project_cutoff_file_data;
      let ids_suc_sel = this.projectAllDiagramations.filter((e: any) => e.id_medio == this.medio_sel.id);
      if (this.medio_sel.inventario_type != 1 || this.medio_sel.formato === 2) {
        ids_suc_sel = ids_suc_sel.filter((e: any) => e.id_pop == this.pop_sel.id);
      }
      ids_suc_sel = ids_suc_sel.map((d: any) => d.pop_config.map((pc: any) => pc.sucursales.map((s: any) => s.id)).flat()).flat();

      const sucursalCantidadMap: Record<number, number> = {};
      this.projectAllDiagramations.filter((e: any) => e.id_medio == this.medio_sel.id).forEach((diagram: any) => {
        diagram.pop_config.forEach((pc: any) => {
          pc.sucursales.forEach((s: any) => {
            if (!sucursalCantidadMap[s.id]) {
              sucursalCantidadMap[s.id] = 0;
            }
            sucursalCantidadMap[s.id] += Number(s.cantidad);
          });
        });
      });

      let sucursalesInvalidas: any = [];
      if (this.medio_sel.formato === 3) {
        sucursalesInvalidas = ids_suc_sel.filter((id: number) => {
          const sucursal = file_suc_full.find((s: any) => s.id === id);
          if (!sucursal) return false;
          let atributoMax = Object.keys(sucursal).find(key => key.includes(this.arr_reglas.filter((reg: any) => reg.cant_type === 4)[0].atributo));
          if (!atributoMax) return false;
          const maxPermitido = Number(sucursal[atributoMax]);
          return sucursalCantidadMap[id] >= maxPermitido;
        });
      }

      this.storeFile = this.storeFile.filter((e: any) => !sucursalesInvalidas.includes(e.id));
      if (this.medio_sel.formato === 3) {
        this.storeFile = this.storeFile.filter((e: any) => e[this.arr_reglas.filter((reg: any) => reg.cant_type === 4)[0].atributo] > 0);
      }
    }

    this.storeFile = this.storeFile.map((e: any) => {
      const extra_stores = this.extra_stores_data ? this.extra_stores_data.find((x: any) => x.id == e.id) : null;
      return { ...(extra_stores || {}), ...e };
    });

    if (this.storeFile.length > 0) {
      this.dsstoreFile = new MatTableDataSource(this.storeFile);
      this.dsstoreFile.paginator = this.paginatorSuc;
      this.dsstoreFile.sort = this.sortSuc;

      this.displayedColumnsStore = arr_fields_stores.filter((key: any) => key && !/\bid\b/.test(key.trim()) && key.trim() !== '');
      this.addSpecialFilters();
      this.getPlazas();
    }
  }

  getExtraStoreData() {
    this.projectsS.getExtraSucData(this.id_camp).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          this.extra_stores_data = result.data;
        }
      },
      (err: any) => console.log(err)
    );
  }

  addSpecialFilters() {
    this.dsstoreFile.filterPredicate = (data: any, filter: any) => {
      const filters = JSON.parse(filter);
      for (const column in filters) {
        if (filters[column] && data[column]) {
          const columnValue = data[column].toString().toLowerCase();
          const filterValue = filters[column].toLowerCase();
          if (!columnValue.includes(filterValue)) {
            return false;
          }
        }
      }
      return true;
    };
  }

  applyColumnFilter(column: string, event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.columnFilters[column] = filterValue;
    this.dsstoreFile.filter = JSON.stringify(this.columnFilters);
    if (this.dsstoreFile.paginator) {
      this.dsstoreFile.paginator.firstPage();
    }
  }

  applyColumnFilterSelect(column: string, value: string) {
    const filterValue = value.trim().toLowerCase();
    this.columnFilters[column] = filterValue;
    this.dsstoreFile.filter = JSON.stringify(this.columnFilters);
    if (this.dsstoreFile.paginator) {
      this.dsstoreFile.paginator.firstPage();
    }
  }

  getPlazas() {
    this.plazasList = [...new Set(this.storeFile.map((item: any) => item.Plaza))].sort();
  }

}